import * as creditAppSelectors from '@makemydeal/dr-dash-store/selectors/creditAppSelectors';
import * as creditDecisionSelectors from '@makemydeal/dr-dash-store/selectors/creditDecisionSelectors';
import * as dealXgDetailsSelectors from '@makemydeal/dr-dash-store/selectors/dealXgDetailsSelectors';
import * as navigationActionCreators from '@makemydeal/dr-dash-store/actions/navigationActionCreators';
import * as shopperNotificationsSelectors from '@makemydeal/dr-dash-store/selectors/shopperNotificationsSelectors';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { ACTIVITY_NAME_CREDIT_APPLICATION } from '@makemydeal/dr-dpm-client';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { useDispatch, useSelector } from 'react-redux';
import SendToCustomerDialogInterstate from '../../sendToCustomerDialog/SendToCustomerDialog.interstate';
import DealActivityCard from '../DealActivityCard.interstate';
import { useCreditAppShareLink } from '../../hooks/useActivityShareLink';
import { CreditAppCardContent } from './CreditAppCardContent';

const name = 'creditApp';

const CreditAppCard = () => {
    const completed = useSelector(creditAppSelectors.isCreditAppCompleted);
    const cardValue = useSelector(creditAppSelectors.getCreditAppCardLabel);
    const notifications = useSelector((state: StateTree) =>
        shopperNotificationsSelectors.getShopperNotificationsByActivity(state, 'creditApp')
    );
    const creditAppDpmState = useSelector((state: StateTree) =>
        dealXgDetailsSelectors.getDpmStateByActivity(state, ACTIVITY_NAME_CREDIT_APPLICATION)
    );
    const { shareLink: sendToCustomerAction, dialogProps } = useCreditAppShareLink();
    const dispatch = useDispatch();
    const enableCreditBureauAndDecisionPBCRouteOne = useSelector(featureToggleSelectors.enableCreditBureauAndDecisionPBCRouteOne);
    const isCreditProviderRouteOne: boolean = useSelector(dealerSelectors.isCreditProviderRouteOne);
    const hasDecisionAvailable = useSelector(creditDecisionSelectors.getLenderCreditDecisions).length > 0;
    const navigateToCreditDecision = () => dispatch(navigationActionCreators.navigateToCreditDecision());

    const shouldRenderCreditAppCardContent =
        !isCreditProviderRouteOne || (enableCreditBureauAndDecisionPBCRouteOne && isCreditProviderRouteOne);

    const linkText = notifications.length ? 'Resend Link' : 'Send Link';

    return (
        <div>
            <DealActivityCard
                showCardAnchor={shouldRenderCreditAppCardContent && hasDecisionAvailable}
                dpmState={creditAppDpmState}
                name={name}
                cardValue={cardValue}
                completed={completed}
                action={shouldRenderCreditAppCardContent && hasDecisionAvailable ? navigateToCreditDecision : sendToCustomerAction}
                htmlId="creditApp-link"
                data-testid="creditApp-link"
                linkText={shouldRenderCreditAppCardContent && hasDecisionAvailable ? 'View' : linkText}
                additionalContent={shouldRenderCreditAppCardContent && <CreditAppCardContent />}
            />

            <SendToCustomerDialogInterstate {...dialogProps} />
        </div>
    );
};

export default CreditAppCard;
